import { render, staticRenderFns } from "./TenantSurvey.vue?vue&type=template&id=28907039&scoped=true"
import script from "./TenantSurvey.vue?vue&type=script&lang=js"
export * from "./TenantSurvey.vue?vue&type=script&lang=js"
import style0 from "./TenantSurvey.vue?vue&type=style&index=0&id=28907039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28907039",
  null
  
)

export default component.exports